var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M125.58,56.69L71.16,5.39c-2.04-1.93-4.76-2.99-7.66-2.99s-5.62,1.06-7.66,2.99L1.42,56.69c-.92.87-1.42,2.01-1.42,3.24s.51,2.37,1.42,3.24c1.89,1.78,4.97,1.78,6.87,0l5.68-5.35v53.83c0,7.14,6.16,12.95,13.74,12.95h70.17c7.58,0,13.74-5.81,13.74-12.95v-55.18l7.1,6.7c.9.85,2.15,1.34,3.43,1.34s2.53-.49,3.43-1.34c1.89-1.78,1.89-4.69,0-6.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilled);
export default __webpack_public_path__ + "static/media/home-filled.8ee9a202e90c2b8a352195ee74b0e15b.svg";
export { ForwardRef as ReactComponent };